(() => {
  const panelSelector = ".jfh-before-after__panel";
  const buttonSelector = ".jfh-before-after__button";
  const boundAttribute = "data-jfh-before-after-bound";

  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  const getClientX = (event) => {
    if (event.touches && event.touches[0]) return event.touches[0].clientX;
    if (event.changedTouches && event.changedTouches[0]) return event.changedTouches[0].clientX;
    return event.clientX;
  };

  const getCurrentPercent = (panel) => {
    const inlineValue = panel.style.getPropertyValue("--percent");
    const computedValue = window.getComputedStyle(panel).getPropertyValue("--percent");
    const percent = parseFloat(inlineValue || computedValue);
    return Number.isFinite(percent) ? percent : 50;
  };

  const setPercent = (panel, percent) => {
    panel.style.setProperty("--percent", `${clamp(percent, 0, 100)}%`);
  };

  const setPercentFromEvent = (panel, event) => {
    const rect = panel.getBoundingClientRect();
    if (!rect.width) return;

    const edgeInset = Math.min(20, rect.width / 2);
    const x = clamp(getClientX(event) - rect.left, edgeInset, rect.width - edgeInset);
    setPercent(panel, (x / rect.width) * 100);
  };

  const initPanel = (panel) => {
    if (panel.hasAttribute(boundAttribute)) return;

    const button = panel.querySelector(buttonSelector);
    if (!button) return;

    panel.setAttribute(boundAttribute, "true");

    let dragging = false;

    const start = (event) => {
      dragging = true;
      panel.classList.add("is-dragging");
      setPercentFromEvent(panel, event);
      event.preventDefault();
    };

    const move = (event) => {
      if (!dragging) return;
      setPercentFromEvent(panel, event);
      event.preventDefault();
    };

    const end = () => {
      dragging = false;
      panel.classList.remove("is-dragging");
    };

    if (window.PointerEvent) {
      panel.addEventListener("pointerdown", (event) => {
        start(event);
        if (panel.setPointerCapture && event.pointerId !== undefined) {
          panel.setPointerCapture(event.pointerId);
        }
      });
      window.addEventListener("pointermove", move);
      window.addEventListener("pointerup", end);
      window.addEventListener("pointercancel", end);
    } else {
      panel.addEventListener("mousedown", start);
      window.addEventListener("mousemove", move);
      window.addEventListener("mouseup", end);
      panel.addEventListener("touchstart", start, { passive: false });
      window.addEventListener("touchmove", move, { passive: false });
      window.addEventListener("touchend", end);
      window.addEventListener("touchcancel", end);
    }

    button.addEventListener("keydown", (event) => {
      const step = event.shiftKey ? 10 : 5;
      const currentPercent = getCurrentPercent(panel);

      if (event.key === "ArrowLeft") {
        setPercent(panel, currentPercent - step);
        event.preventDefault();
      } else if (event.key === "ArrowRight") {
        setPercent(panel, currentPercent + step);
        event.preventDefault();
      } else if (event.key === "Home") {
        setPercent(panel, 0);
        event.preventDefault();
      } else if (event.key === "End") {
        setPercent(panel, 100);
        event.preventDefault();
      }
    });
  };

  const init = (root = document) => {
    root.querySelectorAll(panelSelector).forEach(initPanel);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
